/* T0'BLACK — Header interactions (no dependencies) */
(function () {
  var header = document.querySelector('[data-t0-header]');
  if (!header) return;

  /* Sticky shrink on scroll */
  if (header.classList.contains('is-sticky')) {
    var shrinkAt = 40;
    var ticking = false;
    var apply = function () {
      header.classList.toggle('is-shrunk', window.scrollY > shrinkAt);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(apply); ticking = true; }
    }, { passive: true });
    apply();
  }

  /* Back button
     - En la home: reabre la entrada T0'BLACK (Tienda / Streetwear / Train).
     - En el resto: vuelve a la pagina anterior si fue otra pagina interna
       (p. ej. producto -> streetwear); si se llego desde la home o desde fuera
       del sitio, va directo a la home (tienda), sin pasar por la entrada. */
  var backBtn = header.querySelector('[data-t0-back]');
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (window.T0Entry && window.T0Entry.open()) return;

      var home = '/';
      var ref = null;
      try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) {}
      var fromInternalPage = ref && ref.origin === window.location.origin &&
        ref.pathname !== home && ref.pathname !== window.location.pathname;

      if (fromInternalPage && window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = home;
      }
    });
  }

  /* Mobile drawer */
  var toggle = header.querySelector('[data-t0-toggle]');
  var drawer = document.querySelector('[data-t0-drawer]');
  if (!toggle || !drawer) return;

  var closeBtn = drawer.querySelector('[data-t0-close]');
  var open = function () {
    drawer.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  var close = function () {
    drawer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();
